import { render, staticRenderFns } from "./ScreenLoader.vue?vue&type=template&id=458bc544&scoped=true&"
import script from "./ScreenLoader.vue?vue&type=script&lang=ts&"
export * from "./ScreenLoader.vue?vue&type=script&lang=ts&"
import style0 from "./ScreenLoader.vue?vue&type=style&index=0&id=458bc544&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458bc544",
  null
  
)

export default component.exports